import React from "react";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { convertSecsToWords } from "utils";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function BackupPlanInterval(props) {
  return (
    <div className="intervel flex_align">
      <p>Set backup interval:</p>
      <div className="main_select">
        <select
          onChange={e =>
            props.setPlanSettings({
              ...props.planSettings,
              scheduleInfo: {
                ...props.planSettings.scheduleInfo,
                interval: {
                  ...props.planSettings.scheduleInfo.interval,
                  selected: +e.target.value
                }
              }
            })
          }
          value={props.planSettings.scheduleInfo.interval.selected}
        >
          {props.planSettings.scheduleInfo.interval.values.map((val, i) => (
            <option key={i} value={val}>
              {convertSecsToWords(val)}
            </option>
          ))}
        </select>
      </div>
      <Tooltip {...TOOLTIPS.backupSettings.schedule.interval}>
        <span className="icon">
          <InformationIcon />
        </span>
      </Tooltip>
    </div>
  );
}

export default BackupPlanInterval;
